import * as React from "react";
import { forwardRef } from "react";
const SvgAlertCircle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-circle-alert-icon lucide-circle-alert", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 10 }), /* @__PURE__ */ React.createElement("line", { x1: 12, x2: 12, y1: 8, y2: 12 }), /* @__PURE__ */ React.createElement("line", { x1: 12, x2: 12.01, y1: 16, y2: 16 }));
const ForwardRef = forwardRef(SvgAlertCircle);
export default ForwardRef;
